import { render, staticRenderFns } from "./BudgetCheckInRecords.vue?vue&type=template&id=388ca609&scoped=true"
import script from "./BudgetCheckInRecords.vue?vue&type=script&lang=js"
export * from "./BudgetCheckInRecords.vue?vue&type=script&lang=js"
import style0 from "./BudgetCheckInRecords.vue?vue&type=style&index=0&id=388ca609&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388ca609",
  null
  
)

export default component.exports